var _style, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommonNoimgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "75px",
    height: "75px",
    viewBox: "-452.1 248.3 75 75",
    style: {
      enableBackground: "new -452.1 248.3 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0F0F0;}\r\n\t.st1{fill:#999999;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -452.1,
    y: 248.3,
    className: "st0",
    width: 75,
    height: 75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attach-icon-file",
    transform: "translate(-4.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2",
    transform: "translate(4.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8130",
    className: "st1",
    d: "M-405.4,272.3h-14.3c-0.2,0-0.4,0.1-0.6,0.2l-4.1,4c-0.2,0.1-0.2,0.3-0.2,0.6v21.5 c0,0.4,0.4,0.8,0.8,0.8h18.4c0.4,0,0.8-0.3,0.8-0.8c0,0,0,0,0,0v-25.4C-404.6,272.7-405,272.3-405.4,272.3 C-405.4,272.3-405.4,272.3-405.4,272.3z M-406.2,297.8H-423v-20.3l3.6-3.5h13.2V297.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4",
    transform: "translate(7.502 17.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8131",
    className: "st1",
    d: "M-412.1,272.3h-11.7c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h11.7c0.4,0,0.8-0.3,0.8-0.8 S-411.6,272.3-412.1,272.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_6",
    transform: "translate(7.502 13.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8132",
    className: "st1",
    d: "M-412.1,272.3h-11.7c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8c0,0,0,0,0.1,0h11.7 c0.4,0,0.8-0.3,0.8-0.8C-411.2,272.7-411.6,272.3-412.1,272.3C-412,272.3-412,272.3-412.1,272.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8",
    transform: "translate(7.502 21.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8133",
    className: "st1",
    d: "M-412.1,272.3h-11.7c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8c0,0,0,0,0.1,0h11.7 c0.4,0,0.8-0.3,0.8-0.8C-411.2,272.7-411.6,272.4-412.1,272.3C-412,272.3-412,272.3-412.1,272.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_10",
    transform: "translate(11.114 4.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8134",
    className: "st1",
    d: "M-418.7,272.6c-0.3-0.3-0.8-0.3-1.1,0l-2.4,2.4l-0.9-0.9c-0.3-0.3-0.8-0.3-1.1,0 c-0.3,0.3-0.3,0.8,0,1.1c0,0,0,0,0,0l1.5,1.5c0.3,0.3,0.8,0.3,1.1,0l3-2.9C-418.4,273.4-418.4,272.9-418.7,272.6 C-418.7,272.6-418.7,272.6-418.7,272.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonNoimgFile);
export default __webpack_public_path__ + "static/media/common_noimg_file.19fabefff5a5e95b19fce271dee568fe.svg";
export { ForwardRef as ReactComponent };